import React from "react";
import { formatNumber } from "../../shared/utils";
export const RatingReviews = ({ rating = 0, reviews = 0 }) => {
    return (
      <div className="flex items-center bg-gray-100 rounded-tr-lg rounded-br-lg">
        <div className="w-1 h-6 bg-teal-400 rounded-full" />
        <span className="text-xs font-semibold text-gray-900  ml-2 mr-1">
          {rating.toFixed(1)}
        </span>
        <span className="text-yellow-500 ">★</span>
        <span className="text-xs text-gray-700  pr-1 ml-1">
        ({formatNumber(reviews)})
        </span>
       
      </div>
    );
  };
  